import React from "react";
import { Modal, Button } from "antd";

export interface CustomDialogProps {
  open: boolean;
  title?: React.ReactNode;
  description?: React.ReactNode; // simple text/markup body
  children?: React.ReactNode; // alternate body content
  okText?: string;
  cancelText?: string;
  onOk?: () => void;
  onCancel?: () => void;
  closable?: boolean;
  centered?: boolean;
  maskClosable?: boolean;
  className?: string; // maps to rootClassName
  maskBackground?: string; // convenience for mask bg
  getContainer?: false | HTMLElement | (() => HTMLElement);
  buttonSize?: "small" | "middle" | "large";
  footer?: React.ReactNode; // custom footer override
  styles?: Record<string, any>; // allow extra style overrides
}

const CustomDialog: React.FC<CustomDialogProps> = ({
  open,
  title,
  description,
  children,
  okText = "Okay",
  cancelText,
  onOk,
  onCancel,
  closable = false,
  centered = true,
  maskClosable = false,
  className,
  maskBackground,
  getContainer,
  buttonSize = "small",
  footer,
  styles,
}) => {
  const mergedStyles = {
    mask: maskBackground ? { background: maskBackground } : undefined,
    ...styles,
  } as any;

  const derivedFooter = footer
    ? footer
    : [
        cancelText ? (
          <Button key="cancel" size={buttonSize} onClick={onCancel}>
            {cancelText}
          </Button>
        ) : null,
        <Button
          key="ok"
          size={buttonSize}
          type={cancelText ? undefined : "primary"}
          onClick={onOk}
        >
          {okText}
        </Button>,
      ].filter(Boolean);

  return (
    <Modal
      open={open}
      title={title}
      footer={derivedFooter as any}
      maskClosable={maskClosable}
      closable={closable}
      centered={centered}
      rootClassName={className}
      styles={mergedStyles}
      getContainer={getContainer}
    >
      {children || (description && <p>{description}</p>)}
    </Modal>
  );
};

export default CustomDialog;
